import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';
import { PaginatedResult } from 'Src/models/pageOpts';
import { ServiceError, useError } from 'Src/network/useError';

import service, { VoidReason } from './voidReasonService';

type VoidReasonGetAllReturn = PaginatedResult<VoidReason>;

const queryKeys = {
  getAll: () => ['POS:GET:VoidReasons'],
};

const useVoidReasonQuery_getAll = <T = VoidReasonGetAllReturn>() => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('voidReason.error.getAll') });
  const { currentOperator } = useCurrentOperator();

  return useQuery<VoidReasonGetAllReturn, ServiceError, T>({
    queryKey: queryKeys.getAll(),
    staleTime: Infinity,
    queryFn: async () => {
      try {
        return await service.getAll({});
      } catch (e) {
        throw parseError(e);
      }
    },
    // block usage of this hook until we have a current operator available
    // - resolves the error we see when trying to run this hook automatically via the react-query run when first mounting
    enabled: !!currentOperator,
  });
};

const useVoidReason = {
  query: {
    getAll: useVoidReasonQuery_getAll,
  }
};

export { useVoidReason };
